import { ROOT_DESTINATION } from "./constants";

export const toDestination = (folderId: number | null): string =>
  folderId === null ? ROOT_DESTINATION : String(folderId);

export const toFolderId = (destination: string): number | null =>
  destination === ROOT_DESTINATION ? null : Number(destination);
